<bl-page-card-container
  data-smartpresentation="container-pagina"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>

      <bl-competencia
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>

      <p-multiSelect
        class="ml-2"
        display="chip"
        optionLabel="label"
        optionValue="value"
        [options]="situacaoRpsOptions"
        [(ngModel)]="situacaoRpsSelecionadas"
        dropdownIcon="pi pi-angle-down"
        placeholder="Situação no RPS"
        styleClass="text-sm"
        (onChange)="onFiltroChange()"
        [style]="{ width: '220px', height: '35.38px' }"
        appendTo="body"
      ></p-multiSelect>

      <p-select
        size="small"
        class="ml-2"
        optionLabel="label"
        optionValue="value"
        [options]="pmQualissOptions"
        [(ngModel)]="pmQualissSelecionado"
        dropdownIcon="pi pi-angle-down"
        placeholder="Está no PM-Qualiss?"
        [showClear]="true"
        (ngModelChange)="onFiltroChange()"
        [style]="{ width: '200px', height: '35.38px' }"
        appendTo="body"
      ></p-select>

      <p-select
        size="small"
        class="ml-2"
        optionLabel="label"
        optionValue="value"
        [options]="participacaoEfetivaOptions"
        [(ngModel)]="participacaoEfetivaSelecionada"
        dropdownIcon="pi pi-angle-down"
        placeholder="Participação efetiva em anos anteriores?"
        [showClear]="true"
        (ngModelChange)="onFiltroChange()"
        [style]="{ width: '260px', height: '35.38px' }"
        appendTo="body"
      ></p-select>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 p-button p-button-md flex-shrink-0 white-space-nowrap"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      <bl-pesquisar-input
        class="ml-5 mr-5"
        (onSearch)="onSearch($event)"
        [disabled]="!rowData?.length"
      ></bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only mr-2"
        (click)="exportExcel()"
        [disabled]="!rowData?.length"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
      >
        <i class="pi pi-file-excel"></i>
      </button>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{
            'pi-window-maximize': !(fullscreen$ | async),
            'pi-window-minimize': (fullscreen$ | async)
          }"
        ></i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [style.height]="gridHeight$ | async"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>
    </div>

    <div class="grid-footer">
      <small>Último processamento em: {{ dtUltimoProcessamento || '-' }}</small>
    </div>
  </div>
</bl-page-card-container>